// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import UpdatePassword from '../../_common/UpdatePassword';
import Card from '../Card';

const PasswordRecovery = ({ ...props }) => {
    const {
        state: { active_user },
    } = useGlobalState();

    if (active_user.isLoggedIn) {
        return <Navigate to='/' replace />;
    }

    return (
        <Card title='Password Reset' icon='lock'>
            <UpdatePassword />
        </Card>
    );
}

export default PasswordRecovery;